import { Component }             from '@angular/core';
import { NavController }         from 'ionic-angular';
import { LoadingController }     from 'ionic-angular';
import { dmHotel }               from '../sign-in/xv-hotel';
import { DescriptionsViewModel } from './xv-descriptions';
import { MLText, mlBroker }      from '../../services/MLText';
import { AppDataBroker }         from '../../services/AppData';
import { SignInPage }            from '../sign-in/sign-in';
import { dmLoading }             from '../loading/loading';

@Component({
     selector:    'page-descriptions'
    ,templateUrl: 'descriptions.html'
})
export class DescriptionsPage {
    Descriptions: DescriptionsViewModel;
    NewLoading:   (pMessage: string) => dmLoading;
    BackToSignIn: () => void;

    constructor(
         public navCtrl:       NavController
        ,public loadingCtrl:   LoadingController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel = appDataBroker.GetAppData() as dmHotel;

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.Descriptions = new DescriptionsViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.NewLoading
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/descriptions/descriptions.ts